// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-card {
  border-radius: 1rem !important;
  border-color: #ffff;
  text-align: start;
  background-color: #ffff;
}

.dashboard-card-body {
  display: flex;
  flex-direction: column;
}

.cardInfo {
  border-radius: 1rem;
  width: 50%;
}

.btnAreas {
  color: #090909;
  margin-bottom: 1.25rem;
  padding: 0.7em 1.7em;
  font-size: 18px;
  border-radius: 0.5em;
  background: #afd3e2;
  border: 1px solid #afd3e2;
  transition: all 0.3s;
  box-shadow: 2px 2px 6px #c5c5c5, -2px -2px 6px #ffffff;
}

.btnAreas:hover {
  background-color: #19a7ce;
}
.btnAreas:active {
  color: #666;
  box-shadow: inset 2px 2px 6px #c5c5c5, inset -2px -2px 6px #ffffff;
}

.btnViewAll {
  background-color: var(--color-blue-primary);
  border-color: var(--color-blue-primary);
  color: #ffff;
  border-radius: 10em;
  font-size: 17px;
  font-weight: 600;
  padding: 1em 2em;
  border: 1px solid var(--color-blue-primary);
  /*  box-shadow: 0 0 0 0 black; */
}

.btnViewAll:hover {
  background-color: #19a7ce;
  border-color: #19a7ce;
}

.amount-worksbymodality-box {
  border-radius: 100%;
  height: 30px;
  width: 30px;
  padding: 5px;
}

.title-modality-welcome {
  text-align: start;
  font-weight: 400;
}

.flexColumn {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/Welcome/ModalitiesCard/modalitiesCard.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kEAAkE;AACpE;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".dashboard-card {\n  border-radius: 1rem !important;\n  border-color: #ffff;\n  text-align: start;\n  background-color: #ffff;\n}\n\n.dashboard-card-body {\n  display: flex;\n  flex-direction: column;\n}\n\n.cardInfo {\n  border-radius: 1rem;\n  width: 50%;\n}\n\n.btnAreas {\n  color: #090909;\n  margin-bottom: 1.25rem;\n  padding: 0.7em 1.7em;\n  font-size: 18px;\n  border-radius: 0.5em;\n  background: #afd3e2;\n  border: 1px solid #afd3e2;\n  transition: all 0.3s;\n  box-shadow: 2px 2px 6px #c5c5c5, -2px -2px 6px #ffffff;\n}\n\n.btnAreas:hover {\n  background-color: #19a7ce;\n}\n.btnAreas:active {\n  color: #666;\n  box-shadow: inset 2px 2px 6px #c5c5c5, inset -2px -2px 6px #ffffff;\n}\n\n.btnViewAll {\n  background-color: var(--color-blue-primary);\n  border-color: var(--color-blue-primary);\n  color: #ffff;\n  border-radius: 10em;\n  font-size: 17px;\n  font-weight: 600;\n  padding: 1em 2em;\n  border: 1px solid var(--color-blue-primary);\n  /*  box-shadow: 0 0 0 0 black; */\n}\n\n.btnViewAll:hover {\n  background-color: #19a7ce;\n  border-color: #19a7ce;\n}\n\n.amount-worksbymodality-box {\n  border-radius: 100%;\n  height: 30px;\n  width: 30px;\n  padding: 5px;\n}\n\n.title-modality-welcome {\n  text-align: start;\n  font-weight: 400;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
